import { Box, Text } from "@nulogy/components";
import { formatDateTime, formatDuration } from "components/helpers/format";
import React from "react";
import styled from "styled-components";
import Timespan from "utils/Timespan";

const TimeInformationTable = styled.table(({ theme }) => ({
  borderSpacing: 0,

  td: {
    fontSize: theme.fontSizes.smaller,
    lineHeight: theme.lineHeights.smallerText,
    padding: 0,
    paddingRight: "1px",
  },

  tr: {
    lineHeight: theme.lineHeights.smallerText,
  },
}));

const DateTimeLabel = styled.td(({ theme }) => ({
  color: theme.colors.midGrey,
  fontSize: theme.fontSizes.smaller,
  paddingRight: "4px",
}));

const DateTime = styled.div`
  font-size: 12px;
  display: inline;
`;

export default function BlockTooltip({
  startDate,
  endDate,
  teardownTimeDuration,
  teardownTimeLabel,
  overlappingPlannedBreaks,
}) {
  const duration = new Timespan(startDate, endDate).durationInSeconds();
  const formattedDuration = formatDuration(duration);
  const formattedTeardownTimeDuration = formatDuration(teardownTimeDuration);

  return (
    <>
      <TimeInformationTable>
        <tbody>
          <tr>
            <DateTimeLabel>Starts:</DateTimeLabel>
            <td>
              <DateTime data-testid="starts-at">{formatDateTime(startDate)}</DateTime>
            </td>
          </tr>
          <tr>
            <DateTimeLabel>Ends:</DateTimeLabel>
            <td>
              <DateTime data-testid="ends-at">{formatDateTime(endDate)}</DateTime>
              &nbsp;
              <Text data-testid="duration" fontSize="smaller" fontWeight="medium" inline lineHeight="smallerText">
                ({formattedDuration})
              </Text>
            </td>
          </tr>
        </tbody>
      </TimeInformationTable>
      {(overlappingPlannedBreaks?.length > 0 || teardownTimeDuration > 0) && (
        <Box fontSize="smaller" lineHeight="smallerText" mt="x1">
          {overlappingPlannedBreaks?.map((overlappingPlannedBreak) => (
            <Box
              data-testid={`overlapping-planned-break-${overlappingPlannedBreak.plannedBreakName}`}
              key={overlappingPlannedBreak.plannedBreakName}
            >
              <Text color="midGrey" fontSize="smaller" inline lineHeight="smallerText">
                {overlappingPlannedBreak.plannedBreakName}:{" "}
              </Text>
              <Text fontSize="smaller" fontWeight="medium" inline lineHeight="smallerText">
                {formatDuration(overlappingPlannedBreak.duration)}
              </Text>
            </Box>
          ))}
          {teardownTimeDuration > 0 && (
            <Box fontSize="smaller" lineHeight="smallerText">
              <Text color="midGrey" fontSize="smaller" inline lineHeight="smallerText">
                {teardownTimeLabel}:{" "}
              </Text>
              <Text fontSize="smaller" fontWeight="medium" inline lineHeight="smallerText">
                {formattedTeardownTimeDuration}
              </Text>
            </Box>
          )}
        </Box>
      )}
    </>
  );
}
